import React from 'react';
import { useAuth } from '@/context/AuthContext';
/* import FeatureCard from '@/components/ui/FeatureCard'; */
import StepCard from '@/components/ui/StepCard';
import ConfigurableButton from '@/components/ui/ConfigurableButton';
import { homePageButtons } from '@/config/homePageConfig';
import logo from '@/assets/logo.png';

const HomePage: React.FC = () => {
  const { isAuthenticated, user } = useAuth();

  const getVisibleButtons = () => {
    return homePageButtons.filter(button => {
      if (button.hideWhenAuthenticated && isAuthenticated) {
        return false;
      }

      if (button.requiredAuth && !isAuthenticated) {
        return false;
      }

      if (button.requiredRole && user?.role !== button.requiredRole) {
        return false;
      }

      return true;
    });
  };

  return (
    <>
      {/* SEO Meta Tags - da aggiungere nel componente Head o layout principale */}
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 relative overflow-hidden">
        {/* Background Pattern Decorativo */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-72 h-72 bg-blue-400 rounded-full filter blur-3xl"></div>
          <div className="absolute top-40 right-20 w-96 h-96 bg-purple-400 rounded-full filter blur-3xl"></div>
          <div className="absolute bottom-20 left-1/3 w-80 h-80 bg-indigo-400 rounded-full filter blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 py-16 relative z-10">
          {/* Hero Section Migliorata */}
          <div className="text-center mb-16">
            <div className="inline-block">
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent text-sm font-semibold tracking-wide uppercase">
                <img src={logo} alt="Voglia di Fibra Logo" className="h-[100px] w-[100px] inline-block rounded-[50px]" />
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 mb-6 leading-tight">
              Voglio la{' '}
              <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent">
                Fibra
              </span>
              <span className="inline-block ml-4 bg-red-500 text-white text-sm md:text-base font-semibold px-3 py-1 rounded-full align-top">
                BETA
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-600 mb-4 max-w-3xl mx-auto leading-relaxed">
              Segnala <strong>disservizi e problemi</strong> con la fibra ottica nella tua zona
            </p>

            <p className="text-lg text-gray-500 mb-12 max-w-2xl mx-auto">
              Aiuta la community a monitorare la qualità della connessione internet in Italia.
              Confronta operatori e trova soluzioni rapide.
            </p>

            {/* CTA Buttons con Animation */}
            <div className="flex flex-col md:flex-row  gap-8 md:gap-4 justify-center mb-12 w-full ">
              {getVisibleButtons().map(button => (
                <div key={button.id} className="francesco  w-full flex transform hover:scale-105 transition-all duration-300 md:shadow-lg md:hover:shadow-xl">
                  <ConfigurableButton config={button} />
                </div>
              ))}
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap justify-center items-center gap-8 text-sm text-gray-500 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-green-500">✓</span>
                <span>Gratuito al 100%</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-green-500">✓</span>
                <span>Tutti gli operatori</span>
              </div>
              {/*    <div className="flex items-center gap-2">
                <span className="text-green-500">✓</span>
                <span>Community verificata</span>
              </div> */}
            </div>

            {/* Disclaimer */}
            <div className="max-w-4xl mx-auto mb-16">
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 shadow-sm">
                <div className="flex items-start gap-3">
                  <span className="text-amber-500 text-xl mt-0.5">⚠️</span>
                  <div>
                    <h3 className="font-semibold text-amber-800 mb-2">Disclaimer Importante</h3>
                    <p className="text-sm text-amber-700 leading-relaxed">
                      Questo servizio è <strong>completamente indipendente</strong> e non è affiliato con nessun operatore di telecomunicazioni.
                      È una piattaforma gratuita gestita dalla community per raccogliere segnalazioni su zone d'ombra e problemi nella copertura fibra.
                      <strong>Non abbiamo contatti diretti con gli operatori</strong> - speriamo che le segnalazioni possano essere utili per future valutazioni delle aree problematiche.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Features Section Migliorata */}
          {/*   <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-20">
            <div className="transform hover:scale-105 transition-all duration-300 bg-white/80 backdrop-blur-sm rounded-lg border border-white/20 shadow-xl hover:shadow-2xl min-h-[200px] min-w-[300px] flex items-center">
              <FeatureCard
                icon="📍"
                title="Geolocalizzazione Precisa"
                description="Seleziona facilmente la tua posizione sulla mappa interattiva per segnalare problemi specifici della zona. Sistema GPS integrato per massima precisione."
              />
            </div>

            <div className="transform hover:scale-105 transition-all duration-300 bg-white/80 backdrop-blur-sm rounded-lg border border-white/20 shadow-xl hover:shadow-2xl min-h-[200px] min-w-[300px] flex items-center">
              <FeatureCard
                icon="📶"
                title="Test Diagnostici Avanzati"
                description="Indica il tipo di linea, velocità effettiva raggiunta e problemi specifici. Tool integrati per test di velocità e latenza in tempo reale."
              />
            </div>

            <div className="transform hover:scale-105 transition-all duration-300 bg-white/80 backdrop-blur-sm rounded-lg border border-white/20 shadow-xl hover:shadow-2xl min-h-[200px] min-w-[300px] flex items-center">
              <FeatureCard
                icon="🔧"
                title="Risoluzione Rapida"
                description="Gli operatori ricevono notifiche immediate e possono aggiornare lo stato dei lavori. Tracking completo fino alla risoluzione del problema."
              />
            </div>
          </div> */}

          {/* Stats Section */}
          {/*   <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 mb-20 border border-white/20 shadow-xl">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">12,847</div>
                <div className="text-gray-600 text-sm">Segnalazioni Totali</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-green-600 mb-2">8,934</div>
                <div className="text-gray-600 text-sm">Problemi Risolti</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-purple-600 mb-2">156</div>
                <div className="text-gray-600 text-sm">Città Coperte</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-600 mb-2">24h</div>
                <div className="text-gray-600 text-sm">Tempo Medio Risposta</div>
              </div>
            </div>
          </div>
 */}
          {/* How it Works Section Migliorata */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Come Funziona la Segnalazione
            </h2>
            <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
              Processo semplice e veloce in 3 step per aiutare tutta la community
            </p>

            <div className="max-w-5xl mx-auto">
              <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
                <div className="transform hover:scale-105 transition-all duration-300 bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-6 w-[280px] flex items-center">
                  <StepCard
                    stepNumber={1}
                    title="📍 Seleziona Posizione"
                    description="Clicca sulla mappa interattiva per indicare il punto esatto dove riscontri il problema di connessione"
                  />
                </div>

                {/* Connettore animato */}
                <div className="hidden md:flex items-center">
                  <div className="w-8 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 animate-pulse"></div>
                  <div className="text-purple-400 text-xl ml-2">→</div>
                </div>

                <div className="transform hover:scale-105 transition-all duration-300 bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-lg p-6 w-[280px] flex items-center">
                  <StepCard
                    stepNumber={2}
                    title="📝 Descrivi il Problema"
                    description="Fornisci dettagli specifici: tipo di connessione, velocità misurata, orario e natura del disservizio"
                  />
                </div>

                <div className="hidden md:flex items-center">
                  <div className="w-8 h-0.5 bg-gradient-to-r from-purple-400 to-green-400 animate-pulse"></div>
                  <div className="text-green-400 text-xl ml-2">→</div>
                </div>

                <div className="transform hover:scale-105 transition-all duration-300 bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-lg p-6 w-[280px] flex items-center">
                  <StepCard
                    stepNumber={3}
                    title="⏳ Attendere Eventuale Risoluzione"
                    description="In base a quanto spiegato nel disclaimer, non vi è certezza che un operatore prenderà in carico il problema. Si spera che segnalazioni numerose possano portare a future valutazioni della zona"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Operatori Supportati */}
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 border border-white/20 shadow-xl">
            <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
              Operatori Monitorati
            </h3>
            <div className="flex flex-wrap justify-center items-center gap-8 text-gray-600">
              <div className="flex items-center gap-2 text-lg font-semibold">
                🔴 TIM
              </div>
              <div className="flex items-center gap-2 text-lg font-semibold">
                🟡 Fastweb
              </div>
              <div className="flex items-center gap-2 text-lg font-semibold">
                🔴 Vodafone
              </div>
              <div className="flex items-center gap-2 text-lg font-semibold">
                🟠 WindTre
              </div>
              <div className="flex items-center gap-2 text-lg font-semibold">
                🟢 Altri Operatori
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;